module.exports = __webpack_public_path__ + "img/KQLogo.52fea2c8.png";